import { useState } from 'react'
import { getPersistenceClient } from '../runtime/persistenceClient'

const persistence = getPersistenceClient()

export function useExternalLinkPrompt() {
  const [pendingExternalUrl, setPendingExternalUrl] = useState<string | null>(null)

  function requestOpenExternalLink(url: string): void {
    setPendingExternalUrl(url)
  }

  async function confirmOpenExternalLink(): Promise<void> {
    if (!pendingExternalUrl) return
    const ok = await persistence.openExternalLink(pendingExternalUrl)
    if (!ok) {
      window.open(pendingExternalUrl, '_blank', 'noopener,noreferrer')
    }
    setPendingExternalUrl(null)
  }

  return {
    pendingExternalUrl,
    setPendingExternalUrl,
    requestOpenExternalLink,
    confirmOpenExternalLink
  }
}
